import { node, arrayOf, string, oneOfType, object } from 'prop-types'

const Div = ({ children, cssClass, otherProps = {}, style = {} }) => {
  return (
    <div className={cssClass} {...otherProps} style={style}>
      {children}
    </div >
  )
}

Div.propTypes = {
  children: oneOfType([arrayOf(node), node]),
  cssClass: string,
  otherProps: object,
  style: object
}

export default Div
